import Icon from '@admin/components/icon'
import PropTypes from 'prop-types'
import React from 'react'

const SendingRateToken = (props) => (
  <div className={`sending-rate-token${props.sending_rate_delta === 0 ? '' : props.sending_rate_delta > 0 ? ' up' : ' down'}`}>
    { props.sending_rate_delta !== 0 && <Icon svg="triangle" /> }
    { props.sending_rate }
  </div>
)

SendingRateToken.propTypes = {
  sending_rate: PropTypes.number.isRequired,
  sending_rate_delta: PropTypes.number.isRequired
}

export default SendingRateToken